import { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | undefined = undefined;

/**
 * Get a QueryClient instance for use in router loaders.
 * Loaders run outside React context, so we use a singleton pattern.
 */
export function getQueryClient() {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 5 * 60 * 1000 // 5 minutes
        }
      }
    });
  }
  return queryClient;
}
